<template>
  <router-view></router-view>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'app',
  created () {
    if (this.loading) {
      this.onLoading()
    } else {
      this.offLoading()
    }
    this.$store.watch(state => this.$store.getters['register/register'], value => {
      if (value && this.auth) {
        this.dataInitialize()
        this.$router.push({path: '/'})
      }
    })
    this.$store.watch(state => this.$store.getters['dispatch/auth'], value => {
      if (value && this.register) {
        this.dataInitialize()
        this.$router.push({path: '/'})
      }
    })
    this.$store.watch(state => this.$store.getters['dispatch/loading'], value => {
      if (value) {
        this.onLoading()
      } else {
        this.offLoading()
      }
    })
  },
  computed: {
    ...mapGetters({
      auth: 'dispatch/auth',
      loading: 'dispatch/loading',
      register: 'register/register'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue